export default "/_next/static/images/df9b15ed5bcc95550f3d727e07f482ec.png";